export const translations = {
    EN: {
        home: "HOME",
        about: "ABOUT",
        procedures: "PROCEDURES",
        surgeries: "SURGERIES",
        shop: "SHOP",
        login: "LOGIN",
        createAccount: "CREATE ACCOUNT",
        myAccount: "MY ACCOUNT",
        logout: "SIGN OUT",
        welcome: "WELCOME TO",
        headlinePart1: "YOUR",
        headlinePart2: "NEW YOU",
        subheadline: "Plastic & Reconstructive Surgery",
        bookAppointment: "Book Appointment",
        whatsapp: "WhatsApp",
        surgeonProfileTitle: "Surgeon Profile",
        bookConsultation: "Book a Consultation",
        comingSoonTitle: "COMING SOON...",
        comingSoonSubtitle: "Enter your email to receive updates and news from us.",
        emailPlaceholder: "Your email adress",
        sendButton: "SEND",
        ourExpertise: "OUR EXPERTISE",
        surgeonDescription: "Dr. Juan David Salazar is a distinguished board-certified Plastic and Reconstructive Surgeon committed to improving patients' well-being and self-esteem. He possesses a unique ability to personalize the most contemporary surgical techniques, providing harmonious, balanced, and natural results for the face, breasts, and body.\nOriginally from Colombia, Dr. Salazar discovered his passion for medicine while being surrounded by doctors in his family. This inspired him to pursue an international career in plastic surgery.",
        moreBtn: "More",
        faceliftTitle: "FACE LIFTING",
        faceliftDesc: "Face lifting is at the core of Dr. Salazar's facial rejuvenation philosophy. Each case is meticulously planned to achieve facial harmony, restore youthful contours, and provide a natural look that reflects each patient's individuality.",
        beforeLabel: "BEFORE",
        afterLabel: "AFTER",
        medicalTitle: "PREMIUM MEDICAL TOURISM",
        medicalSubtitle: "Your Exclusive Transformation Journey",
        step1Title: "Virtual Consultation",
        step1Desc: "Schedule an online evaluation with Dr. Salazar to discuss your goals and create a personalized surgical plan.",
        step2Title: "Travel & Agenda",
        step2Desc: "Arrive in Cali or Bogota and enjoy a curated agenda of cultural and gastronomic activities tailored for your visit.",
        step3Title: "Procedure Day",
        step3Desc: "We pick you up from your luxury accommodation and transfer you to our premium clinic for your procedure.",
        step4Title: "Elite Aftercare",
        step4Desc: "Experience luxury aftercare with 24/7 dedicated professional nursing care in a safe, premium recovery environment.",
        step5Title: "Expert Follow-up",
        step5Desc: "Direct post-surgical monitoring by Dr. Salazar to ensure your results are permanent, natural, and perfect.",
        whyCaliTitle: "Visit Colombia: The Country of Beauty",
        climateTitle: "PERFECT CLIMATE",
        climateDesc: "Ideal temperature year-round",
        gastroTitle: "GASTRONOMY",
        gastroDesc: "Unique flavors of Colombia",
        cultureTitle: "VIBRANT CULTURE",
        cultureDesc: "Capital of salsa and art",
        hospTitle: "HOSPITALITY",
        hospDesc: "Warmth and exceptional care"
    },
    ES: {
        home: "INICIO",
        about: "SOBRE MÍ",
        procedures: "PROCEDIMIENTOS",
        surgeries: "CIRUGÍAS",
        shop: "TIENDA",
        login: "INICIAR SESIÓN",
        createAccount: "CREAR CUENTA",
        myAccount: "MI CUENTA",
        logout: "CERRAR SESIÓN",
        welcome: "BIENVENIDO A",
        headlinePart1: "TU",
        headlinePart2: "NUEVO YO",
        subheadline: "Cirugía Plástica y Reconstructiva",
        bookAppointment: "Agendar Cita",
        whatsapp: "WhatsApp",
        surgeonProfileTitle: "Perfil del Cirujano",
        bookConsultation: "Agendar Consulta",
        comingSoonTitle: "PRÓXIMAMENTE...",
        comingSoonSubtitle: "Ingresa tu correo para recibir nuestras actualizaciones y noticias.",
        emailPlaceholder: "Tu dirección de correo",
        sendButton: "ENVIAR",
        ourExpertise: "NUESTRA EXPERIENCIA",
        surgeonDescription: "El Dr. Juan David Salazar es un distinguido Cirujano Plástico y Reconstructivo certificado, comprometido en mejorar el bienestar y la autoestima de sus pacientes. Posee una habilidad única para personalizar las técnicas quirúrgicas más contemporáneas, proporcionando resultados armoniosos, equilibrados y naturales para el rostro, senos y cuerpo.\nOriginario de Colombia, el Dr. Salazar descubrió su pasión por la medicina al estar rodeado de médicos en su familia. Esto lo inspiró a seguir una carrera internacional en cirugía plástica.",
        moreBtn: "Ver más",
        faceliftTitle: "LIFTING FACIAL",
        faceliftDesc: "El lifting facial es el núcleo de la filosofía de rejuvenecimiento facial del Dr. Salazar. Cada caso es planificado meticulosamente para lograr armonía facial, restaurar contornos juveniles y proporcionar un aspecto natural que refleje la individualidad de cada paciente.",
        beforeLabel: "ANTES",
        afterLabel: "DESPUÉS",
        medicalTitle: "TURISMO MÉDICO PREMIUM",
        medicalSubtitle: "Tu Viaje de Transformación Exclusivo",
        step1Title: "Consulta Virtual",
        step1Desc: "Agenda una evaluación online con el Dr. Salazar para discutir tus objetivos y crear un plan quirúrgico personalizado.",
        step2Title: "Viaje y Agenda",
        step2Desc: "Llega a Cali o Bogotá y disfruta de una agenda curada de actividades culturales y gastronómicas pensadas para tu visita.",
        step3Title: "Día del Procedimiento",
        step3Desc: "Te recogemos en tu alojamiento de lujo y te trasladamos a nuestra clínica premium para tu cirugía.",
        step4Title: "Aftercare de Élite",
        step4Desc: "Vive un postoperatorio de lujo con enfermería profesional dedicada 24/7 en un entorno premium y seguro.",
        step5Title: "Seguimiento Experto",
        step5Desc: "Monitoreo post-quirúrgico directo por el Dr. Salazar para asegurar resultados permanentes, naturales y perfectos.",
        whyCaliTitle: "Visita Colombia: El País de la Belleza",
        climateTitle: "CLIMA PERFECTO",
        climateDesc: "Temperatura ideal todo el año",
        gastroTitle: "GASTRONOMÍA",
        gastroDesc: "Sabores únicos de Colombia",
        cultureTitle: "CULTURA VIBRANTE",
        cultureDesc: "Capital de la salsa y el arte",
        hospTitle: "HOSPITALIDAD",
        hospDesc: "Calidez y atención excepcional"
    },
    PT: {
        home: "INÍCIO",
        about: "SOBRE MIUM",
        procedures: "PROCEDIMENTOS",
        surgeries: "CIRURGIAS",
        shop: "LOJA",
        login: "ENTRAR",
        createAccount: "CRIAR CONTA",
        myAccount: "MINHA CONTA",
        logout: "SAIR",
        welcome: "BEM-VINDO AO",
        headlinePart1: "SEU",
        headlinePart2: "NOVO EU",
        subheadline: "Cirurgia Plástica e Reconstrutiva",
        bookAppointment: "Agendar Consulta",
        whatsapp: "WhatsApp",
        surgeonProfileTitle: "Perfil do Cirurgião",
        bookConsultation: "Agendar Consulta",
        comingSoonTitle: "EM BREVE...",
        comingSoonSubtitle: "Insira seu e-mail para receber nossas atualizações.",
        emailPlaceholder: "Seu endereço de e-mail",
        sendButton: "ENVIAR",
        ourExpertise: "NOSSA EXPERIÊNCIA",
        surgeonDescription: "O Dr. Juan David Salazar é um distinto Cirurgião Plástico e Reconstrutivo certificado, comprometido em melhorar o bem-estar e a autoestima de seus pacientes. Ele possui uma habilidade única de personalizar as técnicas cirúrgicas mais contemporâneas, proporcionando resultados harmoniosos, equilibrados e naturais para o rosto, seios e corpo.\nOriginalmente da Colômbia, o Dr. Salazar descobriu sua paixão pela medicina estando cercado por médicos em sua família. Isso o inspirou a seguir uma carreira internacional em cirurgia plástica.",
        moreBtn: "Ver mais",
        faceliftTitle: "LIFTING FACIAL",
        faceliftDesc: "O lifting facial está no centro da filosofia de rejuvenescimento facial do Dr. Salazar. Cada caso é planejado meticulosamente para alcançar harmonia facial, restaurar os contornos juvenis e proporcionar uma aparência natural que reflete a individualidade de cada paciente.",
        beforeLabel: "ANTES",
        afterLabel: "DEPOIS",
        medicalTitle: "TURISMO MÉDICO PREMIUM",
        medicalSubtitle: "Sua Jornada de Transformação Exclusiva",
        step1Title: "Consulta Virtual",
        step1Desc: "Agende uma avaliação online com o Dr. Salazar para discutir seus objetivos e criar um plano cirúrgico personalizado.",
        step2Title: "Viagem e Agenda",
        step2Desc: "Chegue a Cali ou Bogotá e desfrute de uma agenda selecionada de atividades culturais e gastronômicas para sua visita.",
        step3Title: "Dia do Procedimento",
        step3Desc: "Buscamos você em sua acomodação de luxo e o transferimos para nossa clínica premium para seu procedimento.",
        step4Title: "Aftercare de Elite",
        step4Desc: "Experimente um pós-operatório de luxo com enfermagem profissional dedicada 24 horas por dia, 7 dias por semana.",
        step5Title: "Acompanhamento Especializado",
        step5Desc: "Monitoramento pós-cirúrgico direto pelo Dr. Salazar para garantir resultados permanentes, naturais e perfeitos.",
        whyCaliTitle: "Visite a Colômbia: O País da Beleza",
        climateTitle: "CLIMA PERFEITO",
        climateDesc: "Temperatura ideal o ano todo",
        gastroTitle: "GASTRONOMIA",
        gastroDesc: "Sabores únicos da Colômbia",
        cultureTitle: "CULTURA VIBRANTE",
        cultureDesc: "Capital da salsa e da arte",
        hospTitle: "HOSPITALIDADE",
        hospDesc: "Calor e atendimento excepcional"
    }
};
